import { render } from "./Home.vue?vue&type=template&id=1cec2b15&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=1cec2b15&scoped=true&lang=css"

import exportComponent from "/home/computacionucat/ucat-evaluacion-desempeno-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cec2b15"]])

export default __exports__